export const computeTypeNames = {
    0: 'UNKNOWN',
    1: 'CONTROL',
    2: 'APP',
    3: 'NIO',
  };

